export default "__VITE_ASSET__bh0KoX9W__"